<template>
  <div>
    <div id="FirmaDocumento_div" class="w-100 px-5 py-4">
      <div id="Titulo_div">
        <h1>FIRMAR DOCUMENTO</h1>
        <h3 style="color: black;">Ingrese la información para poder firmar su documento</h3>
      </div>
      <div class="d-flex row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 padding-div-low">
          <div class="area">
            <h6>Paso 1: Ingresar el tipo de firma electrónica con el que desea firmar sus documentos</h6>
            <hr />
            <h6>Tipo de firma electrónica</h6>
            <C048TiposFirmaElectronica v-on:valorParaElPadre="cambioDeTipoDeFirmaElectronica" :prefijo="catalogo.etiquetaDeHtml" :tipo="catalogo.tipoDeSelect" :idDelInput="'tipoFirmaElectronica'" :parametros="{}" :valorDefinido="tipoDeFirmaId"></C048TiposFirmaElectronica>
          </div>
        </div>
        <div v-if="tipoDeFirmaId != -1" class="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9 padding-div-low">
          <div class="area">
            <div v-if="tipoDeFirmaId == 1" id="subidordefirmaelectronica_FIREL_div">
              <h5>Paso 2: Suba su archivo de firma electrónica FIREL (.PFX) e ingrese su contraseña</h5>
              <hr />
              <h6>Selecciona el certificado FIREL (.PFX)</h6>
              <input type="file" id="firel_pfx" ref="" class="form-control" v-on:change="subirPFX($event)" accept=".pfx,.PFX" />
              <hr />
              <h6>Ingrese la contraseña de su FIREL</h6>
              <input type="password" id="firel_contrasena" class="form-control" v-model="PFX_Contrasena" placeholder="Ingrese la contraseña de su FIREL" v-on:keyup="validarFIREL()" />
            </div>
            <div v-else-if="tipoDeFirmaId == 2" id="subidordefirmaelectronica_FIEL_div">
              <h5>Paso 2: Suba su archivo de firma electrónica FIEL (.CER) e ingrese su llave (.KEY)</h5>
              <hr />
              <h6>Seleccione el archivo FIEL (.CER)</h6>
              <input type="file" id="fiel_cer" ref="" class="form-control" v-on:change="subirCER($event)" accept=".cer,.CER" />
              <hr />
              <h6>Seleccione el archivo FIEL (.KEY)</h6>
              <input type="file" id="fiel_key" ref="" class="form-control" v-on:change="subirKEY($event)" accept=".key,.KEY" />
            </div>
            <div v-if="mostrarSubidorDeArchivos" id="subidordearchivos_div">
              <br />
              <br />
              <h5>Paso 3: Suba el documento que requiere firmar</h5>
              <hr />
              <div>
                <h6>Seleccione el archivo (.PDF) a firmar</h6>
                <input type="file" id="archivoafirmar" v-on:change="subirPDF($event)" class="form-control" accept="application/pdf" />
              </div>
            </div>
            <div v-if="mostrarRealizarLaSubida" id="realizarlasubida_div" class="text-right">
              <br />
              <button class="btn btn-default" v-on:click="firmarDocumento()">
                <i class="fas fa-file-signature"></i>&nbsp;&nbsp;Firmar el documento
              </button>
            </div>
            <div v-if="archivosFirmados.length > 0" class="table-responsive">
              <hr />
              <table class="table table-striped table-light table-hover">
                <thead class="thead-dark">
                  <tr>
                    <th class="text-center">Documento</th>
                    <th class="text-center">Mensaje</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody class="text-dark">
                  <tr v-if="archivosFirmados.length <= 0">
                    <td colspan="3" class="text-center">No existen registros de documentos firmados</td>
                  </tr>
                  <tr v-else v-for="archivoFirmado in archivosFirmados" v-bind:key="archivoFirmado.NombreDelArchivo">
                    <td>{{archivoFirmado.NombreDelArchivo}}</td>
                    <td class="text-center">{{archivoFirmado.Satisfactorio}}</td>
                    <td v-html="crearLaDescargaDelArchivo(archivoFirmado.RutaDelArchivoFirmado)" class="text-center">
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'

  export default {
    data() {
      return {
        enumeraciones,
        catalogo: { etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
        tipoDeFirmaId: -1,
        PFX: null,
        PFX_Contrasena: "",
        CER: null,
        KEY: null,
        PDF: null,
        mostrarSubidorDeArchivos: false,
        mostrarRealizarLaSubida: false,
        archivosFirmados: []
      }
    },
    components: {
      C048TiposFirmaElectronica: catalogos.PJ.C048TiposFirmaElectronica
    },
    methods: {
      cambioDeTipoDeFirmaElectronica: function(datos) {
        this.mostrarSubidorDeArchivos = false;
        this.mostrarRealizarLaSubida = false;
        $("#firel_pfx").val('');
        this.PFX_Contrasena = "";
        $("#fiel_cer").val('');
        $("#fiel_key").val('');
        $("#archivoafirmar").val('');
        this.archivosFirmados = [];

        this.tipoDeFirmaId = parseInt(datos.target.value);
      },
      subirPFX: function(evento) {
        if(this.verificaQueSeaElDocumentoCorrecto(evento.target.files[0].name, "pfx") == false) {
          comun.mensajeDeAlerta("El documento que esta subiendo no es un archivo PFX.<br/><br/>Verifique el documento e inténtelo de nuevo.", null, null);
          $("#firel_pfx").val('');
          this.PFX = null;
          return;
        }

        if(evento.target.files.length > 0)
          this.PFX = evento.target.files[0];
        else {
          $("#firel_pfx").val('');
          this.PFX = null;
        }

        this.validarFIREL();
      },
      validarFIREL: function() {
        if($("#firel_contrasena").val() == null || $("#firel_contrasena").val() == undefined || $("#firel_contrasena").val() == "") {
          this.mostrarSubidorDeArchivos = false;
          return;
        }

        if(this.PFX == null) {
          this.mostrarSubidorDeArchivos = false;
          return;
        }

        this.mostrarSubidorDeArchivos = true;
      },
      subirCER: function(evento) {
        if(this.verificaQueSeaElDocumentoCorrecto(evento.target.files[0].name, "cer") == false) {
          comun.mensajeDeAlerta("El documento que esta subiendo no es un archivo CER.<br/><br/>Verifique el documento e inténtelo de nuevo.", null, null);
          $("#fiel_cer").val('');
          this.CER = null;
          return;
        }

        if(evento.target.files.length > 0)
          this.CER = evento.target.files[0];
        else {
          $("#fiel_cer").val('');
          this.CER = null;
        }

        this.validarFIEL();
      },
      subirKEY: function(evento) {
        if(this.verificaQueSeaElDocumentoCorrecto(evento.target.files[0].name, "key") == false) {
          comun.mensajeDeAlerta("El documento que esta subiendo no es un archivo KEY.<br/><br/>Verifique el documento e inténtelo de nuevo.", null, null);
          $("#fiel_key").val('');
          this.KEY = null;
          return;
        }

        if(evento.target.files.length > 0)
          this.KEY = evento.target.files[0];
        else {
          $("#fiel_key").val('');
          this.KEY = null;
        }

        this.validarFIEL();
      },
      validarFIEL: function() {
        if(this.subirCER == null) {
          this.mostrarSubidorDeArchivos = false;
          return;
        }

        if(this.subirPFX == null) {
          this.mostrarSubidorDeArchivos = false;
          return;
        }

        this.mostrarSubidorDeArchivos = true;
      },
      subirPDF: function(evento) {
        if(this.verificaQueSeaElDocumentoCorrecto(evento.target.files[0].name, "pdf") == false) {
          comun.mensajeDeAlerta("El documento que esta subiendo no es un archivo PDF.<br/><br/>Verifique el documento e inténtelo de nuevo.", null, null);
          $("#archivoafirmar").val('');
          this.PDF = null;
          this.mostrarRealizarLaSubida = false;
          return;
        }

        if(evento.target.files.length > 0) {
          this.PDF = evento.target.files[0];
          this.mostrarRealizarLaSubida = true;
        } else {
          $("#archivoafirmar").val('');
          this.PDF = null;
          this.mostrarRealizarLaSubida = false;
        }
      },
      verificaQueSeaElDocumentoCorrecto: function(nombre, extension) {
        const nombreCortado = nombre.split(".");
        let siEsUnDocumentoValido = false;

        if (nombreCortado[nombreCortado.length - 1].toLowerCase() === extension.toLowerCase())
          siEsUnDocumentoValido = true;

        return siEsUnDocumentoValido;
      },
      firmarDocumento: function(){
        comun.SeEstaCargandoInformacion(true);
        this.archivosFirmados = [];

        let datosDelFormulario = new FormData();

        if(this.PFX != null)
          datosDelFormulario.append('PFX', this.PFX);

        if(this.PFX != null)
          datosDelFormulario.append('Contrasena', this.PFX_Contrasena);

        if(this.CER != null)
          datosDelFormulario.append('CER', this.CER);

        if(this.KEY != null)
          datosDelFormulario.append('KEY', this.KEY);

        if(this.PDF != null)
          datosDelFormulario.append('PDF', this.PDF);

        datosDelFormulario.append('EsPrueba', this.enumeraciones.EsPrueba);

        axios.post(
          api.conexion + api.FirmaElectronica.funcion.FirmarDocumentos,
          datosDelFormulario,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, true)
          ).then(respuesta => {
            if(respuesta.data.SiHayError){
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
              this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
            } else {
              comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
              this.archivosFirmados = respuesta.data.Respuestas;
            }

            comun.SeEstaCargandoInformacion(false);
          }
          ).catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            comun.SeEstaCargandoInformacion(false);
            this.archivosFirmados = [];
          });
      },
      crearLaDescargaDelArchivo: function(rutaDelArchivo){
        return '<a href="' + api.conexion + api.Comun.funcion.DescargarArchivo + '?rutaDelArchivo=' + rutaDelArchivo + '"><i class="fas fa-file-download"></i></a>';
      }
    }
  }
</script>

<style scoped>
  .padding-div-low {
    padding-top: 40px;
  }

  a {
    cursor: pointer;
    text-decoration: none;
  }

  #FirmaDocumento_div .area {
    box-shadow: none;
    background-color: var(--gris-pj-100);
    color: black;
    box-shadow: -4px 5px 10px 1px rgba(143,142,142,0.51);
  }

  #FirmaDocumento_div thead th {
    background-color: var(--verde-pj-100);
  }
</style>



// WEBPACK FOOTER //
// src/components/FirmaElectronica/FirmarDocumentos/FirmarDocumentos.vue